import {NextSeo} from "next-seo";
import {useEffect, useState} from "react";
import {useInView} from 'react-intersection-observer';
import {useRouter} from "next/router";
import {gsap} from "gsap";
import dynamic from "next/dynamic";
// import CTAV3 from "../components/CTA-v3";
// import TestimonialV1 from "../components/Testimonial-v1";
// import WhoIs from "../components/home/WhoIs";
// import Newsletter from "../components/home/Newsletter";
// import Investors from "../components/home/Investors";
// import EasyTrade from "../components/EasyTrade";
// import USP from "../components/USP";
// import Products from "../components/home/Products";
// import Invest from "../components/home/Invest";
// import Services from "../components/Services";
// import Banner from "../components/home/Banner";
//
const Banner = dynamic(() => import("../components/home/Banner"));
const Services = dynamic(() => import("../components/Services"));
const Invest = dynamic(() => import("../components/home/Invest"));
const Products = dynamic(() => import("../components/home/Products"));
const USP = dynamic(() => import("../components/USP"));
const Newsletter = dynamic(() => import("../components/home/Newsletter"));
const WhoIs = dynamic(() => import("../components/home/WhoIs"));
const TestimonialV1 = dynamic(() => import("../components/Testimonial-v1"));
const CTAV3 = dynamic(() => import("../components/CTA-v3"));
const EasyTrade = dynamic(() => import("../components/EasyTrade"));
const Investors = dynamic(() => import("../components/home/Investors"));
const Home = ({data, winWidth}) => {
    const [offset, setOffset] = useState('90');
    const getPost = data && data;
    const {ref, inView} = useInView();
    const [windowWidth, setWindowWidth] = useState(0);
    const router = useRouter();
    const currentUrl = router && router.asPath;

    let page_data = getPost?.data?.page_data

    const home_banner = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'banner');
    const feature_box = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'feature-box');
    const services = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'serivecs');
    const investing = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'investing');
    const products = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'products-home');
    const expert = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'expert');
    const easytrade = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'easy-trade');
    const easyx = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'easy-x');
    const investor = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'investment-calculator');
    const newsletter = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'news-letter');
    const who = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'unbelievable');
    const testimonial = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'testimonial');
    const cta = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'cta');
    const modaldata = getPost?.data?.sections?.find(f => f?.section_data?.slug === 'opening-popup');

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         // Place your hook-based code here
    //         const box = document.querySelectorAll('.box');
    //         const boxplus = document.querySelectorAll('.boxr');
    //         const cta = document.querySelectorAll('.cta');
    //         let reveal = gsap.utils.toArray(".reveal");
    //         reveal.forEach((cont) => {
    //             let img = cont.querySelector("img");
    //             let tl = gsap.timeline({
    //                 scrollTrigger: {
    //                     trigger: cont,
    //                     toggleActions: "restart none none reset",
    //                 },
    //             });
    //             // parallax
    //             // if () {
    //             gsap.to(img, {
    //                 yPercent: 15,
    //                 ease: "none",
    //                 scrollTrigger: {
    //                     trigger: cont,
    //                     // markers: true,
    //                     scrub: true
    //                 }
    //             });
    //             // }
    //
    //             // image reveal
    //             tl.fromTo(
    //                 cont,
    //                 1.5,
    //                 {
    //                     xPercent: -100,
    //                     ease: "Expo.easeInOut",
    //                 },
    //                 {
    //                     xPercent: 0,
    //                     ease: "Expo.easeInOut",
    //                 }
    //             );
    //
    //             tl.fromTo(
    //                 img,
    //                 1.5,
    //                 {
    //                     xPercent: 100,
    //                     ease: "Expo.easeInOut",
    //                     scale: 1.1,
    //                 },
    //                 {
    //                     delay: -1.5,
    //                     xPercent: 0,
    //                     scale: 1,
    //                     ease: "Expo.easeInOut",
    //                 }
    //             );
    //         });
    //
    //
    //         box.forEach((el, index) => {
    //             gsap.fromTo(el, {
    //                 y: -150,
    //                 ease: "none",
    //             }, {
    //                 y: 0,
    //                 autoAlpha: 1,
    //                 ease: "power2",
    //                 duration: 1,
    //                 scrollTrigger: {
    //                     id: `${index + 1}`,
    //                     trigger: el,
    //                     scrub: true
    //                 }
    //             });
    //         });
    //
    //         boxplus.forEach((el, index) => {
    //             gsap.fromTo(el, {
    //                 y: 150,
    //                 ease: "none",
    //             }, {
    //                 y: 0,
    //                 autoAlpha: 1,
    //                 ease: "power2",
    //                 duration: 1,
    //                 scrollTrigger: {
    //                     id: `${index + 1}`,
    //                     trigger: el,
    //                     scrub: true
    //                 }
    //             });
    //         });
    //         cta.forEach((el, index) => {
    //             gsap.fromTo(el, {
    //                 y: -50,
    //                 ease: "none",
    //             }, {
    //                 y: 0,
    //                 autoAlpha: 1,
    //                 ease: "power2",
    //                 duration: 1,
    //                 scrollTrigger: {
    //                     id: `${index + 1}`,
    //                     trigger: el,
    //                     scrub: true
    //                 }
    //             });
    //         });
    //
    //     }
    // }, [Router, router.pathname]);

    // get offset for container
    useEffect(() => {
        if (window.innerWidth > 767) {
            setOffset(document.querySelector('.container').offsetLeft + 15)
        }

    })


    useEffect(() => {
        const updateOffset = () => {
            if (window.innerWidth > 767) {
                const container = document.querySelector('.container');
                if (container) {
                    setOffset(container.offsetLeft + 15);
                }
            }
        };

        // Add an event listener for the DOMContentLoaded event
        document.addEventListener('DOMContentLoaded', updateOffset);

        // Add event listener to update offset on window resize
        window.addEventListener('resize', updateOffset);
        window.addEventListener('load', updateOffset);

        return () => {
            document.removeEventListener('DOMContentLoaded', updateOffset);
            window.removeEventListener('resize', updateOffset);
            window.removeEventListener('load', updateOffset);
        };
    }, []);

    useEffect(() => {
        // Function to handle window resize
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Initial window width
        setWindowWidth(window.innerWidth);

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const location = useRouter();

    useEffect(() => {
        // Use GSAP to animate opacity from 0 to 1
        gsap.to('.hide', {alpha: 1, visibility: 'visible', display: 'block', duration: 0.5, delay: 1});
    }, [location.pathname]); // Run this effect only once when the component mounts


    console.log(getPost, 'ok')
    return (
        <>
            <NextSeo
                title={getPost?.data?.page_data?.meta_title}
                description={getPost?.data?.page_data?.meta_description}
                openGraph={{
                    type: 'website',
                    url: currentUrl,
                    title: page_data?.og_title,
                    description: page_data?.og_description,
                    images: [
                        {
                            url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                        {
                            url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                    ],
                }}
            />

            <Banner data={home_banner} windowWidth={windowWidth} offset={offset} feature_data={feature_box}/>
            <Services services_data={services}/>
            <Invest data={investing} offsetContainer={offset}/>

            <div ref={ref}>
                <Products data={products}/>
                <USP data={expert} offset={offset}/>
                <div className="home_easy_trade">
                    <EasyTrade data={easytrade}/>
                </div>
                <div className="home_easy_trade">
                    <EasyTrade version data={easyx}/>
                </div>
                <Investors
                    id="investor_calculator"
                    data={investor}
                    offset={offset}
                />
                <Newsletter data={newsletter}/>
                <WhoIs data={who}/>
                <TestimonialV1 data={testimonial}/>
                <CTAV3 data={cta} winWidth={winWidth} offset={offset}/>
            </div>

        </>
    );
};

// run this line
// http://cms.shantasecurities.com/api/get-req-data/sections?type=slug&value=landing-page&get_section=yes&image=yes&file=yes&gallery=yes&post=yes
export async function getServerSideProps() {
    try {
        // Get API URL from environment variable or fallback to localhost
        const apiUrl = process.env.NEXT_PUBLIC_API_URL || 'http://cms.shantasecurities.com/api/';
        // Fetch data from API
        const res = await fetch(`${apiUrl}get-req-data/sections?type=slug&value=landing-page&get_section=yes&image=yes&file=yes&gallery=yes&post=yes`);
        
        if (!res.ok) {
            console.error('API request failed:', res.status, res.statusText);
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        
        const data = await res.json();
        
        // Pass fetched data as props to the component
        return {
            props: {
                data,
            },
        };
    } catch (error) {
        console.error('Failed to fetch data:', error);
        // Return empty data as fallback
        return {
            props: {
                data: { data: { sections: [], page_data: {} } },
            },
        };
    }
}

export default Home;
